import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import FileUpload from "react-material-file-upload";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddComplaint = ({ show, onClose, refresh }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [files, setFiles] = useState(null);

    // subscriber
    const [filter_subs_id, setFilterSubsID] = useState(null);
    const [subsribersOpt, setSubscribersOpt] = useState([]);
    useEffect(() => {
        const params = {
            branch_id: branch_id
        };
        axios.get(`${baseURL}/leadsubscription/subscribers`, { params: params })
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.subscriber,
                    label: item.lead_name,
                }));
                setSubscribersOpt(formatted);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    // date time
    const [date, setDate] = useState(null);
    const handledatechange = (selectedDate) => {
        if (selectedDate) {
          const formattedDate = selectedDate.format('YYYY-MM-DD HH:mm:ss');
          setDate(formattedDate);
        } else {
          setDate(null);
        }
    }

    // prods option & on select
    const [filter_prods_id, setFilterProdsID] = useState(null);
    // const [productsOpt, setProductsOpt] = useState([]);
    // useEffect(() => {
    //     axios.get(`${baseURL}/dropdown/package`)
    //         .then(response => {
    //             const formatted = response.data.data.map(item => ({
    //                 value: item.sno,
    //                 label: item.package_name,
    //             }));
    //             setProductsOpt(formatted);
    //         })
    //         .catch(error => {
    //             console.error('There was an error fetching the data!', error);
    //         });
    // }, []);

    const [productsOpt, setProductsOpt] = useState([]);
    useEffect(() => {
        if(filter_subs_id) {
        axios.get(`${baseURL}/subscriber/package/${filter_subs_id}`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.package_name,
                }));
                setProductsOpt(formatted);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
        }
    }, [filter_subs_id]);

    // complaint type
    const [complaint_type_id, setComplaintType] = useState(null);
    const [complainttypeOpt, SetcomplaintTypeOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/dropdown/complainttype`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.complainttype_name,
                }));
                SetcomplaintTypeOpt(formatted);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    // complaint
    const [complaint, setComplaint] = useState('');

    // date picker
    const datePickerRef = useRef();
    const handleClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };



    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!filter_subs_id) {
            newErrors.subs = "This Field is Required.";
        }

        if (!date) {
            newErrors.date = "This Field is Required.";
        }

        if (!filter_prods_id) {
            newErrors.prods = "This Field is Required.";
        }

        if (!complaint_type_id) {
            newErrors.ctype = "This Field is Required.";
        }

        if (!complaint) {
            newErrors.compl = "This Field is Required.";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        } else {
            setErrors({});
        }

        const formData = new FormData();

        // Append regular fields
        formData.append('datetime', date);
        formData.append('subscriber_id', filter_subs_id);
        formData.append('product', filter_prods_id);
        formData.append('complaint_type', complaint_type_id);
        formData.append('complaint', complaint);
        formData.append('branch_id', branch_id);

        if (files && files.length > 0) {
            files.forEach((file, index) => {
                formData.append('attachments[]', file);
            });
        }

        // for (let pair of formData.entries()) {
        //     console.log(pair[0] + ':', pair[1]);
        // }

        axios.post(`${baseURL}/complaint`, formData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Complaint Created Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Complaint Creation Failed");
            });
    };

    const [fileerrors, setfileErrors] = useState([]);
    const handleFileChange = (selectedFiles) => {
        const maxFileSize = 5 * 1024 * 1024; // 5MB
        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/gif",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        const newErrors = [];
        const validFiles = selectedFiles.filter((file) => {
            if (!allowedTypes.includes(file.type)) {
                newErrors.push(`"${file.name}" is not a supported file type.`);
                return false;
            }
            if (file.size > maxFileSize) {
                newErrors.push(`"${file.name}" exceeds 5MB.`);
                return false;
            }
            return true;
        });

        setFiles(validFiles);
        setfileErrors(newErrors);
    };


    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title  text-white">Create Complaint</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Date / Time<span className="required">*</span></label>
                            <div className="datepicker-wrapper d-flex" onClick={handleClick}>
                                <div className="input-group-text bg-transparent border-0 px-0">
                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                </div>
                                <DatePicker placeholder='Select Date Time'
                                    ref={datePickerRef}
                                    onChange={handledatechange}
                                    format="MM-DD-YYYY hh:mm A"
                                    plugins={[
                                        <TimePicker position="bottom" />
                                    ]}
                                    disableDayPicker={false}
                                    maxDate={new Date(new Date().setHours(23, 59, 59, 999))}
                                    className="custom-datepicker"
                                />
                            </div>
                            {errors.date && <div className="text-danger fs-8 mt-1">{errors.date}</div>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Customer<span className="required">*</span></label>
                            <Select  placeholder='Select Customer'
                                value={subsribersOpt.find(option => option.value === filter_subs_id) || null}
                                onChange={(selectedOption) => setFilterSubsID(selectedOption.value)}
                                options={subsribersOpt}
                            />
                            {errors.subs && <div className="text-danger fs-8 mt-1">{errors.subs}</div>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Package <span className="required">*</span></label>
                            <Select placeholder='Select Package'
                                options={productsOpt}
                                value={productsOpt.find(option => option.value === filter_prods_id) || null}
                                onChange={(selectedOption) => setFilterProdsID(selectedOption.value)}
                            />
                            {errors.prods && <div className="text-danger fs-8 mt-1">{errors.prods}</div>}
                        </div>
                        <div className="col-lg-6 mb-2">
                            <label className="text-black font-w500 fs-7">Complaint Type <span className="required">*</span></label>
                            <Select placeholder='Select Complaint Type'
                                options={complainttypeOpt}
                                value={complainttypeOpt.find(option => option.value === complaint_type_id) || null}
                                onChange={(selectedOption) => setComplaintType(selectedOption.value)}
                            />
                            {errors.ctype && <div className="text-danger fs-8 mt-1">{errors.ctype}</div>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Complaint <span className="required">*</span></label>
                            <textarea rows={3} className="form-control h-auto" name="comment" placeholder="Complaint" 
                                maxLength={500}
                                value={complaint}
                                onChange={e => setComplaint(e.target.value)}
                            />
                            {errors.compl && <div className="text-danger fs-8 mt-1">{errors.compl}</div>}
                        </div>
                        
                        <div className='col-lg-12 mb-4'>
                            <label className="text-black font-w500 fs-7">Attachment</label>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>File Type: jpg, png, pdf, docx<br></br>Maximun File Size: 5Mb</span></Tooltip>} >
                                <Button variant="tp-btn-light px-2 py-1" style={{ color: 'black' }}>
                                    <span><i className="fa-solid fa-circle-info fs-6 mt-1"></i></span>
                                </Button>
                            </OverlayTrigger>
                            <div className='mt-2'>
                                <FileUpload value={files} onChange={handleFileChange} />
                            </div>
                            {fileerrors.length > 0 && (
                                <div className="text-danger mt-2">
                                    {fileerrors.map((error, index) => (
                                        <div key={index}>{error}</div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Complaint<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddComplaint;
